import { categories } from "@/mocks/comics";

const quickLinks = [
  { label: "精选推荐", href: "#featured" },
  { label: "高分排行", href: "#ranking" },
  { label: "漫画分类", href: "#categories" },
  { label: "新作速递", href: "#new" },
  { label: "专题解读", href: "#articles" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer id="contact" className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-white">
                <i className="ri-book-open-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl text-white">香香漫画</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              香香漫画精选优质好看漫画，高分排行、编辑推荐、热门分类一网打尽。好看优质漫画，点开即看。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "B站" },
              ].map((item) => (
                <a
                  key={item.label}
                  href="#home"
                  aria-label={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-200 transition-colors hover:bg-primary-500 hover:text-white"
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-white">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-white">热门分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.name}>
                  <a
                    href="#categories"
                    className="text-sm text-background-300 transition-colors hover:text-accent-400"
                  >
                    {cat.name}漫画
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-white">联系我们</h3>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
                support@xiangxiang-manhua.com
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-customer-service-2-line text-accent-400" aria-hidden="true"></i>
                服务时间：每天 9:00 - 21:00
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-message-3-line mt-0.5 text-accent-400" aria-hidden="true"></i>
                意见与建议欢迎随时来信，我们会认真阅读每一条反馈
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-700 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © 2026 香香漫画 版权所有 · 精选优质好看漫画
          </p>
          <p className="flex items-center gap-1.5 text-xs text-background-400">
            <i className="ri-heart-3-fill text-primary-500" aria-hidden="true"></i>
            用热爱发现每一部好漫画
          </p>
        </div>
      </div>
    </footer>
  );
}